<!--退出项目-->
<template>
  <!--  <el-button size="small" type="primary" @click="quitProject" v-if="$store.getters['right/getRole'] != 'project'">退出项目</el-button>-->
  <span class="quitButton" size="small" @click="quitProject"
        v-has-role="['manager','analyzer','saler','auditor','customer']">{{quitMessage}}
        <i class="el-icon-refresh-left"></i>
  </span>
</template>
<script>
export default {
  name: 'QuitProject',
  // props: ['childMsg'],
  data() {
    return {
      quitMessage: '',
    }
  },
  created() {
  },
  mounted() {
    var routePath = this.$route.path
    if (routePath === '/analyzeContent'||routePath==='/analyzeInformation'||routePath==='/errModule') {
      this.quitMessage = '退出分析'
    } else {
      this.quitMessage = '退出项目'
    }
  },
  methods: {
    quitProject() {
      var routePath = this.$route.query.projectId
      if (this.quitMessage === '退出分析') {
        this.quitMessage = '退出项目'
        this.$router.push({
          path: '/analyze',
          query: {projectId: routePath}
        });
      } else {
        this.$router.push('/sampleUpload')
      }
    }
  }
}
</script>

<style scoped>
.el-button {
  float: right;
  margin-right: 30px;
}

.quitButton {
  margin-left: 30px;
  cursor: pointer;
  background-color: #fbc446;
  border: 0px !important;
  color: rgb(255, 255, 255);
  font-size: 15px;

}

.quitButton:hover {
  border: 0px !important;
  /*background-color: #e8d7a7;*/
  color: #949898;
}
</style>
